import type { FilterColumnType, FilterOperatorDef } from "./types";

export const DEFAULT_OPERATORS: Record<FilterColumnType, FilterOperatorDef[]> = {
  text: [
    { value: "EQ", label: "Is" },
    { value: "contains", label: "Contains" },
    { value: "startsWith", label: "Starts With" },
    { value: "endsWith", label: "Ends With" },
  ],
  number: [
    { value: "EQ", label: "Equals" },
    { value: "GT", label: "Greater Than" },
    { value: "GTE", label: "Greater Than or Equal" },
    { value: "LT", label: "Less Than" },
    { value: "LTE", label: "Less Than or Equal" },
  ],
  date: [
    { value: "EQ", label: "Equals" },
    { value: "GT", label: "After" },
    { value: "GTE", label: "After or On" },
    { value: "LT", label: "Before" },
    { value: "LTE", label: "Before or On" },
  ],
  select: [{ value: "EQ", label: "Equals" }],
  "multi-select": [
    { value: "contains", label: "Contains" },
    { value: "not contains", label: "Does Not Contain" },
  ],
};

export const OPERATOR_SYMBOL_MAP: Record<string, string> = {
  GT: ">",
  GTE: "≥",
  LT: "<",
  LTE: "≤",
  EQ: "=",
};
